import type { MFCampaign, MFCampaignReview } from "state/members/accessReviews";
import { isOwnerSignOff } from "pages/Members/Attestations/signOff";

/**
 * Owner sign-off (attestation-only) cycles (PLO-5185) live in the SAME campaign
 * list, side panel and resource rows as standard ones, so the few places where
 * the two differ are decided here rather than inline in the components:
 *
 * - the progress meter counts systems signed off, not resources reviewed;
 * - a system row opens its attestation instead of the account-review screen;
 * - the account-level stats are all zero for a sign-off cycle, so anything
 *   reading them is hidden.
 */

type CampaignKind = Pick<MFCampaign, "reviewType">;
type ReviewLink = Pick<MFCampaignReview, "id" | "attestationId">;

// An entitlement-only cycle (PLO-5731) still has one review per resource, and
// this meter counts reviews — so the label stays "Resources reviewed" and the
// only split here remains sign-off vs everything else.
export const campaignProgressLabel = (
  campaign: CampaignKind,
): "Systems attested" | "Resources reviewed" =>
  isOwnerSignOff(campaign) ? "Systems attested" : "Resources reviewed";

export const resourceRowHref = (review: ReviewLink): string =>
  review.attestationId
    ? `/members/attestations/${review.attestationId}`
    : `/members/access-reviews/reviews/${review.id}`;

export const showsAccountStats = (campaign: CampaignKind): boolean =>
  !isOwnerSignOff(campaign);
